import { BadgeV3, ColorOption } from '@cimplico/components';

type SummaryTableTitleProps = {
    count: string;
    title: string;
    status?: string;
    statusBadgeColor?: ColorOption;
};

function SummaryTableTitle({ count, title, status, statusBadgeColor }: SummaryTableTitleProps): JSX.Element {
    return (
        <div className="flex gap-4">
            <BadgeV3 rounded color="gray" label={count} size="small" />
            <h3 className="font-medium text-gray-600">{title}</h3>
            {status && statusBadgeColor && <BadgeV3 color={statusBadgeColor} label={status} size="small" />}
        </div>
    );
}

export default SummaryTableTitle;
